// extracted by mini-css-extract-plugin
export default {"form":"styles_form__KJvbi","radio":"styles_radio__v4cYK","buttons":"styles_buttons__bDHGS"};